import { FC } from 'react';

import styles from './ProfileCardSmall.module.scss';

interface ProfileCardSmallProps {
  imageSrc: string;
  name: string;
  title: string;
}

const ProfileCardSmall: FC<ProfileCardSmallProps> = ({
  imageSrc,
  name,
  title
}) => {
  return (
    <div className={styles.profileCard}>
      <figure className={styles.imageWrapper}>
        <img src={imageSrc} alt={name} className={styles.image} />
      </figure>
      <div className={styles.textWrapper}>
        <h3 className={styles.name}>{name}</h3>
        <p className={styles.title}>{title}</p>
      </div>
    </div>
  );
};

export default ProfileCardSmall;
